import { RefObject, useEffect } from "react"

interface UseIntersectionObserverProps {
  target: RefObject<Element>
  onIntersect: () => void
  enabled?: boolean
  threshold?: number
  rootMargin?: string
}

export function useIntersectionObserver({
  target,
  onIntersect,
  enabled = true,
  threshold = 0.1,
  rootMargin = "0px",
}: UseIntersectionObserverProps) {
  useEffect(() => {
    if (!enabled || !target.current) return

    const element = target.current

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            onIntersect()
          }
        })
      },
      {
        threshold,
        rootMargin,
      }
    )

    observer.observe(element)

    return () => {
      if (element) {
        observer.unobserve(element)
      }
    }
  }, [target, enabled, onIntersect, threshold, rootMargin])
}
